<template>
  <div class="shop-cart">
    <Breadcrumb />

    <!-- 标题 -->
    <div class="shop-table">
      <el-row :gutter="10">
        <el-col :span="4"> 填写订单信息 </el-col>
        <el-col :span="14" :offset="6">
          <el-steps :active="2" align-center class="step">
            <el-step title="查看购物车"></el-step>
            <el-step title="确认订单信息"></el-step>
            <el-step title="完成支付"></el-step>
          </el-steps>
        </el-col>
      </el-row>
    </div>

    <!-- 收货地址 -->
    <div class="form-body common-limit">
      收货地址
      <div class="receive-info border">
        <div class="r" v-if="currentAddr !== null">
          <el-row>
            <el-col :span="16">
              <span style="margin: 0 8px 0 8px">
                {{ dictMap["amazon_site"][currentAddr.state] }}
                {{ currentAddr.province }}
                {{ currentAddr.city }}
                {{ currentAddr.county }}
                {{ currentAddr.detailAddr }}</span
              >
              <span>{{ currentAddr.zipCode }} </span>
            </el-col>
            <el-col :span="3">{{ currentAddr.receName }} </el-col>
            <el-col :span="5"> {{ currentAddr.mobile }} </el-col>
          </el-row>
        </div>
        <div class="update-address" v-if="currentAddr && currentAddr.addrId">
          <el-button type="text" @click="updateAddr">修改地址</el-button>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div
          style="
            width: 35%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <el-button type="warning" icon="el-icon-location" @click="checkAddr">
            更换地址
          </el-button>
          <el-button type="primary" icon="el-icon-circle-plus" @click="addAddr">
            添加地址
          </el-button>
        </div>
      </div>
    </div>

    <!-- 订单归属 -->
    <div class="form-body common-limit">
      <div style="padding-bottom: 10px">订单归属</div>
      <div class="border" style="padding: 18px; margin-bottom: 10px">
        <el-form ref="orderform" :model="form" label-width="100px" inline>
          <el-form-item label="订单号：">
            <el-input
              size="small"
              style="width: 220px"
              v-model="form.order"
              placeholder="选填，输入的内容将生成订单号"
            ></el-input>

            <el-tooltip
              class="item"
              effect="dark"
              content="订单号说明：cod模式以客户下单的订单为准（面单上有），其他模式任意！ "
              placement="top"
            >
              <i class="el-icon-question" style="margin-left: 5px"> </i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="运单号：">
            <el-input
              size="small"
              style="width: 220px"
              v-model="form.trackingNumber"
              placeholder="选填，输入的内容将生成运单号"
            ></el-input>
            <el-tooltip
              class="item"
              effect="dark"
              content="运单号说明：cod模式客户下单的物流上的运单号为准（面单上有），其他模式任意！ "
              placement="top"
            >
              <i class="el-icon-question" style="margin-left: 5px"> </i>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            prop="channel"
            label="渠道："
            :rules="[
              { required: true, message: '请输入渠道', trigger: 'blur' },
            ]"
          >
            <el-select
              @change="handleSelectChannel"
              clearable
              size="small"
              v-model="form.channel"
            >
              <el-option
                v-for="(value, index) in dictData['plat_no']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="shop"
            label="归属店铺："
            :rules="[
              { required: true, message: '请输入归属店铺', trigger: 'change' },
            ]"
          >
            <el-select
              placeholder="请选择归属店铺"
              clearable
              filterable
              size="small"
              v-model="form.shop"
            >
              <el-option
                v-for="value in shopList"
                :key="value.shopId"
                :label="value.shopName"
                :value="value.shopId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 物流方式 -->
    <div class="form-body common-limit">
      <div style="padding-bottom: 10px">物流方式</div>
      <div class="border" style="padding: 18px; margin-bottom: 10px">
        <el-row :gutter="10" style="margin-bottom: -10px">
          <el-col :span="4">
            <div>
              {{
                currentShip.shipping_method_name
                  ? currentShip.shipping_method_name
                  : "请选择物流"
              }}
            </div>
            <el-button
              type="text"
              @click="handleShowShip"
              style="margin-bottom: -20"
            >
              修改物流方式
            </el-button>
          </el-col>
          <el-col :span="6">
            物流费用：<span v-if="currentShip.shipping_fee > 0"
              >￥ {{ currentShip.shipping_fee }}</span
            ><span v-else>-</span>
          </el-col>
          <el-col :span="14">
            物流参考时限：{{ currentShip.delivery_range }}
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 商品信息 -->
    <div class="form-body common-limit">
      商品信息
      <div class="tab-content border">
        <el-table :data="tableData" stripe ref="shopCartTable">
          <el-table-column label="商品信息" align="center" width="500">
            <template slot-scope="scope">
              <div class="tab-sku-col">
                <div class="sku-img">
                  <img
                    :src="
                      scope.row.activeSku.picList &&
                      scope.row.activeSku.picList.length > 0
                        ? `${scope.row.activeSku.picList[0].picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                        : ''
                    "
                  />
                  <div class="sku-title">
                    {{ scope.row.proName }}
                  </div>
                </div>
                <div class="sku-attr">
                  <el-row
                    v-for="(i, ind) in [0, 1]"
                    :key="'i_' + ind"
                    style="margin: 5px 0"
                  >
                    <div class="proper">
                      <span class="name">
                        {{ scope.row.activeSku.properName.split(":")[i] }}:
                      </span>
                      <span class="value">
                        {{ scope.row.activeSku.properVal.split(":")[i] }}
                      </span>
                    </div>
                  </el-row>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center" class="pro-col">
            <template slot-scope="scope">
              <div class="center">¥ {{ scope.row.unitPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column label="刺绣单价" align="center" class="pro-col">
            <template slot-scope="scope">
              <div class="center">
                ￥{{
                  scope.row.embroideryPrice ? scope.row.embroideryPrice : 0
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" class="pro-col">
            <template slot-scope="scope">
              <div class="center">
                {{ scope.row.productNum }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="小计" align="center" class="pro-col">
            <template slot-scope="scope">
              <div class="center font-red">
                ¥
                {{
                  (
                    (scope.row.unitPrice +
                      (scope.row.embroideryPrice
                        ? scope.row.embroideryPrice
                        : 0)) *
                    scope.row.productNum
                  ).toFixed(2)
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 销售统计 -->
    <div class="form-body common-limit">
      销售统计：{{ dictMap["currency_mark"][saleCountInfo.currency] }}
      {{ saleTotal }}
      <el-row :gutter="10">
        <el-form
          ref="sealCountForm"
          :model="saleCountInfo"
          label-width="80px"
          label-position="left"
        >
          <el-col :span="6">
            <el-form-item label="币别：">
              <el-select
                clearable
                size="small"
                v-model="saleCountInfo.currency"
                placeholder="请选择"
              >
                <el-option
                  v-for="(value, index) in dictData['currency']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品金额：">
              <el-input
                size="small"
                v-model="saleCountInfo.price"
                @change="calculate"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="运费：">
              <el-input
                size="small"
                v-model="saleCountInfo.fee"
                @change="calculate"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="促销：">
              <el-input
                size="small"
                v-model="saleCountInfo.promotion"
                @change="calculate"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>

    <!-- 优惠券 -->
    <div v-if="false" class="form-body common-limit">
      优惠券：
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="币别：">
            <el-select
              clearable
              size="small"
              v-model="saleCountInfo.currency"
              placeholder="请选择"
            >
              <el-option
                v-for="(value, index) in dictData['currency']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品金额：">
            <el-input
              size="small"
              v-model="saleCountInfo.price"
              @change="calculate"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="运费：">
            <el-input
              size="small"
              v-model="saleCountInfo.fee"
              @change="calculate"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <!-- 金额明细 -->
    <div class="form-body common-limit">
      <div class="line-height-40" style="border-bottom: 1px solid #ebeef5">
        金额明细
      </div>
      <div class="order-info line-height-30">
        <br />
        <el-row type="flex" justify="space-between">
          <div></div>
          <el-col :span="16" style="text-align: right">
            <el-row type="flex" justify="space-between">
              <el-col :span="20">商品件数：</el-col>
              <el-col :span="4">
                <span class="form-required">{{ Number(count) }}件</span>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="20">商品总价：</el-col>
              <el-col :span="4">
                <span class="form-required"> ¥{{ total.toFixed(2) }} </span>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="20">刺绣费用：</el-col>
              <el-col :span="4">
                <span class="form-required">
                  ¥{{ embroideryCost.toFixed(2) }}
                </span>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="20"
                ><span class="form-required">运费：</span></el-col
              >
              <el-col :span="4"
                ><span v-if="logisFee > 0" class="form-required"
                  >¥{{ logisFee.toFixed(2) }}</span
                ><span v-else class="form-required">-</span></el-col
              >
            </el-row>
            <el-row type="flex">
              <el-col :span="20">应付总额：</el-col>
              <el-col :span="4">
                <span style="font-size: 16px" class="form-required">
                  ¥{{ (total + logisFee + embroideryCost).toFixed(2) }}
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button type="primary" @click="submitOrder"
                  >提交订单</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 选择收货地址 -->
    <el-dialog
      :close-on-click-modal="false"
      class="addr-sel"
      title="选择收货地址"
      :visible.sync="selectAddrVisible"
      width="650"
      :destroy-on-close="true"
    >
      <div
        class="border single-addr"
        :id="item.addrId + '_addr'"
        v-for="(item, index) in addrList"
        :key="index"
        @click.prevent="clickAddr(item)"
      >
        <el-row>
          <el-col :span="3">收货人：</el-col>
          <el-col :span="21">{{ item.receName }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3">联系方式：</el-col>
          <el-col :span="21">
            {{ item.mobile }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">收货地址：</el-col>
          <el-col :span="21">
            {{ dictMap["amazon_site"][item.state] }} {{ item.province }}
            {{ item.city }} {{ item.county }}
            {{ item.detailAddr }}
          </el-col>
        </el-row>
        <div v-if="item.defaFlag === '1'" class="default-addr">
          <el-button type="text">默认地址</el-button>
          <el-button
            type="text"
            style="color: red"
            @click.stop="deleteAddr(item)"
            >删除</el-button
          >
        </div>
        <div v-else class="set-default">
          <el-button type="text" @click.stop="setDefault(item)">
            设为默认地址
          </el-button>
          <el-button
            type="text"
            style="color: red"
            @click.stop="deleteAddr(item)"
            >删除</el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectAddrVisible = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click.stop="submitSelect">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 修改/添加地址 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="addrTitle"
      :visible.sync="addOrEditVisible"
      :destroy-on-close="true"
    >
      <el-form
        ref="newAddrForm"
        :model="newAddr"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item size="small" label="" required>
          <a style="cursor: pointer" @click="handleShowSetAddress"
            >地址智能识别（自动填写）</a
          >
        </el-form-item>
        <el-form-item size="small" label="所在国家：" required>
          <el-select
            filterable
            clearable
            v-model="newAddr.state"
            placeholder="请选择国家"
          >
            <el-option
              v-for="(value, index) in dictData['amazon_site']"
              :key="index"
              :label="value.label"
              :value="value.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="24">
          <template v-if="newAddr.state === 'CN'">
            <el-col :span="10">
              <el-form-item
                prop="province"
                label="城市/地区："
                label-width="100px"
              >
                <el-select
                  filterable
                  clearable
                  value-key="code"
                  size="small"
                  v-model="newAddr.province"
                  placeholder="省"
                  @change="provinceChange"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="city" label-width="0">
                <el-select
                  filterable
                  clearable
                  value-key="code"
                  size="small"
                  v-model="newAddr.city"
                  placeholder="市"
                  @change="cityChange"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="county" label-width="0">
                <el-select
                  filterable
                  clearable
                  value-key="code"
                  size="small"
                  v-model="newAddr.county"
                  placeholder="区"
                  @change="countyChange"
                >
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-else-if="newAddr.state && newAddr.state !== 'CN'">
            <el-col :span="12">
              <el-form-item label="省份/州" prop="province">
                <el-input size="small" v-model="newAddr.province"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在城市" prop="city">
                <el-input size="small" v-model="newAddr.city"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="县/市" prop="county">
                <el-input
                  size="small"
                  v-model="newAddr.county"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12">
            <el-form-item label="邮编：" prop="zipCode">
              <el-input
                size="small"
                v-model="newAddr.zipCode"
                placeholder="请输入邮编"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="详细地址："
              label-width="100px"
              prop="detailAddr"
            >
              <el-input
                type="textarea"
                size="small"
                v-model="newAddr.detailAddr"
                placeholder="建议您填写详细收货地址，例如街道名称，门牌号码，楼层和房间号等信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="收货人姓名："
              prop="receName"
              label-width="100px"
            >
              <el-input
                size="small"
                v-model="newAddr.receName"
                placeholder="建议填写真实姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号：" prop="mobile" label-width="100px">
              <el-input
                size="small"
                v-model="newAddr.mobile"
                placeholder="请填写正确的手机号码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addOrEditVisible = false">
          取 消
        </el-button>
        <el-button
          v-if="addrTitle === '添加地址'"
          size="small"
          type="primary"
          @click="submitAddNew"
        >
          添 加
        </el-button>
        <el-button v-else size="small" type="primary" @click="submitEdit">
          修 改
        </el-button>
      </div>
    </el-dialog>

    <!-- 修改物流方式 -->
    <el-dialog
      :close-on-click-modal="false"
      title="修改物流方式"
      :visible.sync="changeLogisticsVisible"
      destroy-on-close
    >
      <div>
        <div style="display: flex; line-height: 28px; font-size: 14px">
          <div style="flex: 1">
            重量：{{
              logisticsData.length > 0 && logisticsData[0].total_weight > 0
                ? logisticsData[0].total_weight + "g"
                : "-"
            }}
          </div>
        </div>

        <div
          style="
            display: flex;
            line-height: 28px;
            margin: 0 0 8px 0;
            font-size: 14px;
          "
        >
          <div style="flex: 1">
            收件国家：{{
              dictMap["amazon_site"][currentAddr ? currentAddr.state : ""]
            }}
          </div>
          <div style="flex: 1">
            收件人： {{ currentAddr ? currentAddr.receName : "" }}
          </div>
        </div>
        <el-table
          :data="logisticsData"
          class="border"
          header-cell-class-name="table-header"
          style="width: 100%"
          highlight-current-row
          @current-change="handleCurrentChange"
          @row-click="itemsRowClick"
        >
          >
          <el-table-column label="" class="tableColumnClass">
            <template slot-scope="scope" class="radio"
              ><el-radio
                v-model="radioId"
                :label="scope.row.shipping_method"
                @change="onClickChange(scope.row)"
                >&nbsp;</el-radio
              ></template
            >
          </el-table-column>
          <el-table-column prop="shipping_method_name" label="物流方式">
          </el-table-column>
          <el-table-column prop="shipping_fee" label="物流费用">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.shipping_fee"
                ref="popover1"
                placement="top-start"
                title="物流价格说明"
                width="700"
                trigger="hover"
              >
                <div style="overflow: auto">
                  <div>计费重量 {{ scope.row.total_weight }}克</div>
                  <div v-if="scope.row.detail">
                    物流费用={{ getFormula(scope.row) }}
                  </div>
                  <div v-else>物流费用={{ scope.row.formula_value }}</div>
                  <table
                    v-if="scope.row.detail"
                    class="ship"
                    style="border-collapse: collapse"
                  >
                    <tr>
                      <td>首重价格</td>
                      <td>首重重量</td>
                      <td>续重单位重量</td>
                      <td>续重单位价格</td>
                      <td>操作费</td>
                    </tr>
                    <tr>
                      <td>{{ scope.row.detail.firstPrice }}</td>
                      <td>{{ scope.row.detail.firstWeight }}</td>
                      <td>{{ scope.row.detail.contWeight }}</td>
                      <td>{{ scope.row.detail.contPrice }}</td>
                      <td>{{ scope.row.detail.operCost }}</td>
                    </tr>
                  </table>

                  <table v-else class="ship" style="border-collapse: collapse">
                    <tr>
                      <td>重量区间</td>
                      <td :key="key" v-for="(value, key) in scope.row.prices">
                        {{ value.weight }}
                      </td>
                    </tr>
                    <tr>
                      <td>价格</td>
                      <td :key="key" v-for="(value, key) in scope.row.prices">
                        {{ value.price }}
                      </td>
                    </tr>
                    <tr>
                      <td>固定附加费</td>
                      <td :key="key" v-for="(value, key) in scope.row.prices">
                        {{ value.fee }}
                      </td>
                    </tr>
                  </table>

                  <div>
                    <div>计算公式：{{ scope.row.formula_value }}</div>
                    <div v-if="scope.row.detail">
                      物流费用=[首重价格+⌈(计费重量-首重重量)/续重单位重量⌉*续重单位价格]+操作费<br />
                      注：(计费重量-首重)/续重单位重量，结果需向上取整；公式中的“⌈
                      ⌉”为向上取整符号
                    </div>
                    <div v-else>
                      物流费用={{
                        scope.row.formula_explain_zh
                          ? scope.row.formula_explain_zh
                          : scope.row.detail
                          ? scope.row.detail.referTime
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <div slot="reference">
                  <span
                    >￥{{ scope.row.shipping_fee }} <i class="el-icon-info"></i
                  ></span>
                </div>
              </el-popover>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_range" label="参考时限">
            <template slot-scope="scope" class="radio">
              <span v-if="scope.row.delivery_range">{{
                scope.row.delivery_range
              }}</span>
              <span v-else>{{
                scope.row.detail ? scope.row.detail.referTime : "-"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="changeLogisticsVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeLogisticsVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <SetAddress
      @onClose="handleCloseSetAddress"
      @update="handleSetAddress"
      :visible="showSetAddress"
    ></SetAddress>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listAddr,
  updateAddress,
  addAddress,
  updateDefault,
  delAddr,
  getAddr,
} from "@/api/order/addr"
import { getShopList } from "@/api/system/shopManage"
import { addOrder, getShip } from "@/api/mine/order"
import SetAddress from "./components/SetAddress"
import { findCoupon } from "@/api/business/coupon"

import { mapGetters } from "vuex"

export default {
  name: "settlement",
  components: {
    Breadcrumb,
    SetAddress,
  },
  data() {
    return {
      tableData: [], // 商品列表
      addrList: [], // 所有地址数据
      currentAddr: {}, // 当前地址
      addOrEditVisible: false, // 添加收货地址弹框
      defaultAddr: {}, //存储默认地址
      addrTitle: "", // 地址弹窗标题
      selectAddrVisible: false, // 选择收货地址弹框
      selectAddr: {}, // 选中地址过渡状态
      newAddr: {}, // 修改/添加地址时的临时数据
      provinceOptions: [], // 省份列表
      cityOptions: [], // 城市列表
      areaOptions: [], // 区列表
      radioId: "",
      rules: {
        receName: [
          { required: true, message: "请填写收件人名称", trigger: ["blur"] },
        ],
        mobile: [
          { required: true, message: "请填写收件人手机号", trigger: ["blur"] },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        county: [{ required: true, message: "请选择地区", trigger: "change" }],
        area: [{ required: true, message: "请选择县/市", trigger: "change" }],
        detailAddr: [
          { required: true, message: "请填写详细地址", trigger: "blur" },
        ],
        zipCode: [
          { required: true, message: "请填写邮政编码", trigger: "blur" },
        ],
      },
      shopList: [], // 商铺列表
      total: 0, // 商品总价
      logisFee: 0, // 运费
      payable: 0, // 合计
      count: 0, // 商品件数
      changeT: false, //是否加载地址数据
      form: {
        order: "",
        channel: "",
        shop: "",
      },
      saleTotal: 0, // 销售统计
      saleCountInfo: {
        currency: "",
        price: "",
        fee: "",
        promotion: "",
      },
      embroideryCost: 0, //刺绣费用
      changeLogisticsVisible: false,
      logisticsData: [],
      logisticsDescriptionVisible: false,
      logisticsDescriptionData: [
        {
          first_price: "15",
          first_weight: "500克",
          continued_weight: "500克",
          continued_price: "7",
          operation_fee: "0",
        },
      ],
      currentShip: {},
      isSubmit: false,
      showSetAddress: false,
      couponList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
  },
  async created() {
    this.loadData()
    this.getShopData()
    await this.loadAddr()
    this.loadProvData()
    // this.listCoupon()
    this.getShipList()
  },
  watch: {
    // 更换地址弹窗的"已选择"样式恢复显示
    selectAddrVisible() {
      if (this.selectAddrVisible && this.currentAddr !== null) {
        this.$nextTick(() => {
          this.clickAddr(this.currentAddr) // 更换地址赋值"已选择"样式
        })
      }
    },
  },
  // beforeDestroy() {
  // 	// 离开页面后销毁结算商品
  // 	sessionStorage.removeItem("settlement");
  // },
  methods: {
    handleShowSetAddress() {
      this.showSetAddress = true
    },
    itemsRowClick(row) {
      this.radioId = row.shipping_method
    },
    handleCloseSetAddress() {
      this.showSetAddress = false
    },
    handleSetAddress(address) {
      this.newAddr.city = address.city
      this.newAddr.province = address.province
      this.newAddr.zipCode = address.county_code
      this.newAddr.detailAddr = address.detail
      this.newAddr.receName = address.person
      this.newAddr.mobile = address.phonenum
      this.newAddr.state = address.state
      this.newAddr.county = address.county
      if (address.state == "CN") {
        this.provinceOptions.forEach((item) => {
          if (item.name == address.province) {
            this.cityOptions = item.city
          }
        })
        this.cityOptions.forEach((item) => {
          if (item.name == address.city) {
            this.areaOptions = item.district
            return
          }
        })
      }
      this.showSetAddress = false
    },
    // 获取商品列表
    loadData() {
      let settlement = sessionStorage.getItem("settlement")

      if (settlement !== null) {
        let listData = JSON.parse(settlement)
        this.tableData = listData
      }

      this.count = 0
      this.total = 0
      this.embroideryCost = 0
      this.tableData.forEach((row) => {
        this.count += Number(row.productNum)
        this.total += row.unitPrice * Number(row.productNum)
        this.embroideryCost += row.embroideryCost
      })
      this.payable = this.total + this.logisFee + this.embroideryCost
    },
    getcity() {},
    // 获取商铺列表
    getShopData() {
      getShopList({ platNo: "04" }).then((res) => {
        this.shopList = res.rows
      })
    },
    listCoupon() {
      listCoupon().then((res) => {
        this.couponList = res.rows
      })
    },
    // 当前用户地址数据
    async loadAddr() {
      let response = await listAddr()
      if (response.rows.length > 0) {
        this.addrList = response.rows

        response.rows.map((el) => {
          if (el.defaFlag === "1") {
            this.currentAddr = el
            this.currentShip = {}
          }
        })
      }
    },
    // 获取省市区数据
    loadProvData() {
      $.ajax({
        url: process.env.BASE_URL + "areaData.json",
        method: "get",
        success: (res) => {
          this.provinceOptions = res["regionalDivision"]
        },
      })
    },
    // 修改地址
    updateAddr() {
      this.addOrEditVisible = true
      this.addrTitle = "修改地址"
      let temp = this.currentAddr

      this.provinceOptions.forEach((item) => {
        if (item.name == temp.province) {
          this.cityOptions = item.city
        }
      })

      this.cityOptions.forEach((item) => {
        if (item.name == temp.city) {
          this.areaOptions = item.district
          return
        }
      })

      temp["state"] = temp["state"] || "CN"
      this.newAddr = Object.assign({}, temp)
      this.currentShip = {}
    },
    // 修改地址
    submitEdit() {
      this.$refs["newAddrForm"].validate((valid) => {
        if (valid) {
          this.newAddr.fullAddr = this.jointFull(this.newAddr)
          this.currentAddr = this.newAddr

          updateAddress(this.newAddr).then((res) => {
            if (res.code !== 200) {
              this.$message.error("修改失败，请联系管理员！")
            } else {
              this.$message({ message: "修改成功", type: "success" })
              this.addOrEditVisible = false
              this.changeT = true // 打开更换地址时允许重新加载地址数据
            }
          })
        } else {
          return false
        }
      })
    },

    handleCurrentChange(row) {
      this.currentShip = row
      this.logisFee = Number(this.currentShip.shipping_fee)
    },
    handleSelectChannel() {
      this.form.shop = ""
      getShopList({ platNo: this.form.channel }).then((res) => {
        this.shopList = res.rows
      })
    },
    async handleShowShip() {
      let _self = this
      this.changeLogisticsVisible = true
      this.getShipList()
    },
    async getShipList() {
      let _self = this
      const cartList = []
      this.tableData.map((el) => {
        cartList.push({
          cartId: el.cartId,
        })
      })
      let result = await getShip({
        addrId: this.currentAddr.addrId,
        cartList: cartList,
      })
      result.data.map((record) => {
        if (!record.total_weight) {
          record.total_weight = 0
          record.formula_value = 0
          record.shipping_fee = 0
        }
      })
      for (let record of result.data) {
        let prices = []
        for (let key in record.prices) {
          let object = {
            firstWeight: 0,
            weight: 0,
            price: 0,
            fee: 0,
          }
          let priceArray = record.prices[key].split(":")
          object.weight = key
          if (priceArray.length > 0) {
            object.price = Number(priceArray[0])
          }
          if (priceArray.length > 1) {
            object.fee = priceArray[1]
          }
          object.firstWeight = Number(key.split("-")[0])
          prices.push(object)
        }
        prices = _self._.sortBy(prices, function (item) {
          return Number(item.firstWeight)
        })
        record.prices = prices
      }
      this.logisticsData = result.data
      let rowIndex = 0
      let fee = Number(result.data[0].formula_value)
      for (let a = 0; a < result.data.length; a++) {
        if (Number(result.data[a].formula_value) < fee) {
          rowIndex = a
        }
      }
      this.currentShip = result.data[rowIndex]
      this.logisFee = Number(this.currentShip.shipping_fee)
    },
    // 新增地址
    submitAddNew() {
      this.$refs["newAddrForm"].validate((valid) => {
        if (valid) {
          this.newAddr.defaFlag = "0"
          this.newAddr.fullAddr = this.jointFull(this.newAddr)

          addAddress(this.newAddr).then(async (res) => {
            if (res.code !== 200) {
              this.$message.error("添加失败，请联系管理员！")
            } else {
              this.$message({
                message: "添加成功",
                type: "success",
              })
              //设置当前地址
              let addr = await getAddr(res.msg)
              this.currentAddr = addr.data
              this.addOrEditVisible = false
              this.changeT = true // 打开更换地址时允许重新加载地址数据
            }
          })
        } else {
          return false
        }
      })
    },
    // 设为默认地址
    setDefault(item) {
      updateDefault({
        addrId: item.addrId,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "设置成功",
            type: "success",
          })
          this.loadAddr()
        } else {
          this.$message.error("设置失败")
        }
      })
    },
    // 删除地址
    deleteAddr(item) {
      this.$confirm("是否删除该地址？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delAddr(item.addrId).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.loadAddr()
          } else {
            this.$message.error("删除失败")
          }
        })
      })
    },
    // 更换地址
    checkAddr() {
      if (this.changeT) {
        this.loadAddr()
        this.changeT = false
      }
      this.selectAddrVisible = true
    },
    // 选择要更换的收货地址
    clickAddr(addr) {
      let _dom = document.querySelector(".addr-sel .selected-img")

      if (_dom) {
        // 当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
        _dom.classList.toggle("selected-img")
      }

      if (document.getElementById(addr.addrId + "_addr") != null) {
        document
          .getElementById(addr.addrId + "_addr")
          .classList.toggle("selected-img")
      }

      this.selectAddr = addr
    },
    // 确定更换收货地址
    submitSelect() {
      this.currentAddr = Object.assign({}, this.selectAddr)
      this.selectAddrVisible = false
    },
    // 打开新增地址弹窗
    addAddr() {
      this.addOrEditVisible = true
      this.addrTitle = "添加地址"

      if (this.$refs["newAddrForm"] !== undefined) {
        this.$refs["newAddrForm"].resetFields()
      }

      this.newAddr = {
        receName: undefined,
        mobile: undefined,
        fullAddr: undefined,
        province: undefined,
        city: undefined,
        county: undefined,
        detailAddr: undefined,
        defaFlag: "0",
        zipCode: undefined,
      }
    },
    // 省份下拉修改
    provinceChange(val) {
      this.cityOptions = []
      this.provinceOptions.forEach((item) => {
        if (item.code == val.code) {
          this.cityOptions = item.city
        }
      })
      this.newAddr.province = val.name
      //清空值
      this.newAddr.city = undefined
      this.newAddr.county = undefined
      //不为空时,市和县默认赋值第一个
      if (this.cityOptions.length > 0) {
        this.newAddr.city = this.cityOptions[0].name
        this.cityChange(this.cityOptions[0])
      }
    },
    // 城市下拉修改
    cityChange(val) {
      this.areaOptions = []
      this.cityOptions.forEach((item) => {
        if (item.code == val.code) {
          this.areaOptions = item.district
          return
        }
      })
      this.newAddr.city = val.name

      if (this.areaOptions.length > 0) {
        this.newAddr.county = this.areaOptions[0].name
      }
    },
    // 区县下拉修改
    countyChange(val) {
      this.newAddr.county = val.name
    },
    // 拼接完整地址
    jointFull(addrData) {
      return (
        addrData.province +
        addrData.city +
        addrData.county +
        addrData.detailAddr
      )
    },
    // 计算销售统计
    calculate() {
      this.saleTotal =
        Number(this.saleCountInfo.price || 0) +
        Number(this.saleCountInfo.fee || 0) -
        Number(this.saleCountInfo.promotion || 0)
    },
    // 提交订单
    async submitOrder() {
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      try {
        const cartList = []

        this.tableData.map((el) => {
          cartList.push({
            cartId: el.cartId,
          })
        })
        this.$refs["orderform"].validate()
        if (this.form.channel == "") {
          this.$message({
            message: "请填写渠道",
            type: "error",
          })
          this.isSubmit = false
          return
        }
        if (this.form.shop == "") {
          this.$message({
            message: "请填写归属店铺",
            type: "error",
          })
          this.isSubmit = false
          return
        }

        let orderMap = {
          addrId: this.currentAddr.addrId, // 客户收货地址ID
          shippingMethod: this.currentShip.shipping_method, // 物流方式
          cartList: cartList,
          proTotal: this.total, // 货款产品总价
          proFare: this.currentShip.shipping_fee, // 货款运费
          proDiscount: 0, // 货款优惠金额
          proActPay: this.total + this.logisFee, // 货款实付金额 ， 货款产品总价+货款运费-货款优惠金额
          platNo: this.form.channel,
          shopId: this.form.shop,
          appNo: this.form.order,
          trackingNumber: this.form.trackingNumber,
          currency: this.saleCountInfo.currency,
          saleTotal: this.saleCountInfo.price,
          saleFare: this.saleCountInfo.fee,
          saleDiscount: this.saleCountInfo.promotion,
          saleActPay: this.saleTotal,
          productType: this.tableData[0].productType,
          embroideryCost: this.embroideryCost,
        }

        let res = await addOrder(orderMap)
        if (res.code != 200) {
          this.$message.error("提交失败! 请联系管理员")
        } else {
          this.$message({
            message: "提交成功",
            type: "success",
          })
          this.$store.dispatch("GetIndexStat")

          sessionStorage.removeItem("settlement")
          if (this.showPayButton) {
            this.$router.push({
              path: "/order/myOrder/getPay",
              query: {
                id: res.data,
                platNo: this.form.channel,
              },
            })
          } else {
            this.$router.push({
              path: "/order/myOrder/order",
            })
          }
        }
        this.isSubmit = false
      } catch (error) {
        this.isSubmit = false
      }
    },
    getFormula(ship) {
      let weight = ship.total_weight
      if (weight > ship.detail.firstWeight) {
        return `${ship.detail.firstPrice}+⌈(${weight}-${ship.detail.firstWeight})/${ship.detail.contWeight}⌉*${ship.detail.contPrice}+${ship.detail.operCost}`
      } else {
        return `${ship.detail.firstPrice}+${ship.detail.operCost}`
      }
    },
  },
}
</script>

<style scoped lang="scss">
.shop-cart {
  height: 100%;
  .shop-table {
    padding: 18px;
    border: 1px solid #ebeef5;
    background: #fff;
    font-size: 14px;
    overflow: hidden;
    color: #595a5a;

    .step {
      position: relative;
      right: -75px;
      top: 7px;
    }
  }
}
table.ship {
  border-collapse: collapse;
  td,
  th {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
    padding: 0 2px;
  }
  thead th {
    background-color: #cce8eb;
    width: 100px;
  }
  tr:nth-child(odd) {
    background: #fff;
  }
  tr:nth-child(even) {
    background: #f5fafa;
  }

  td {
    min-width: 76px;
  }
}
</style>
